import { Card, Container } from 'react-bootstrap';
import { useLogoUrl } from '../lib/configSistema';
import '../pages/Login.css';

const NUVENS = ['frente', 'fundo', 'frente', 'fundo', 'frente', 'fundo', 'fundo', 'frente', 'fundo', 'fundo'];

// Moldura das telas públicas (sem login) além do próprio login: mesmo fundo azul com nuvens
// e cartão central — "Esqueci minha senha" e "Redefinir senha".
export default function TelaPublica({ children }) {
  const logoUrl = useLogoUrl();
  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: '100vh', background: 'radial-gradient(circle, #3aa5ff 0%, #097fe2 70%, #004d8e 100%)' }}
    >
      <div className="nuvens">
        {NUVENS.map((tipo, i) => (
          <div key={i} className={`nuvem ${tipo}`} />
        ))}
      </div>
      <Card style={{ width: '100%', maxWidth: 400, zIndex: 1 }} className="shadow-lg border-0">
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <img src={logoUrl} alt="EIMOVEL" style={{ maxWidth: 220 }} />
          </div>
          {children}
        </Card.Body>
      </Card>
    </Container>
  );
}
